// 引用全局变量文件
import global from '../config/index.js'
import router from '@/router'
import Vue from 'vue'
import Bus from '@/utils/bus.js'
import utils from '@/utils'
import expireService from '@/utils/expired'
import {removeCookie} from "../store/cookies";
// 引用axios
var axios = require('axios')

// 将全局变量绑定到全局
var $global_api = global
export default{
  failureHandling (code) {
    if (code == 'ZUUL_ERROR_00002') { // token已过期
      removeCookie('token') // 清除token 及 cookie
      removeCookie('user') // 清除user
      removeCookie('org') // 清除机构
      removeCookie('pool') // 清除下拉框
      removeCookie('query_record')
      removeCookie('ifrm_031')
      expireService.expiredToLogin()
      setTimeout(() => {
        Vue.toasted.show('页面已过期,请重新登录', {
          duration: 3000
        })
        var isIP = utils.isIP(window.location.hostname);
        var expired = 'expired'
        if (!isIP) { // 域名/localhost的情况
          if (window.location.hostname == 'localhost') {
            window.location.href = 'http://localhost:8080/#/byl/login?expired=' + expired
          } else {
            window.location.href = 'http://' + $global_api.DEFAULT_DOMAIN + ':' + $global_api.webport + '/#/byl/login?expired=' + expired
          }
        } else {
          if ($global_api.DEPLOY) {
            window.location.href = 'http://' + window.location.hostname + '/#/byl/login?expired=' + expired
          } else {
            window.location.href = 'http://' + window.location.hostname + ':' + $global_api.webport + '/#/byl/login?expired=' + expired
          }
        }
      }, 500)
    } else {
      axios({
        method: 'GET',
        url: $global_api.dictAPI,
        params: {type: 'message', value: code},
        withCredentials: false
      })
        .then(function (res) {
          if (res.data.result === 'Success') {
            Vue.toasted.show(res.data.data.label)
          } else if (res.data.result === 'Error') {
            console.log(`错误信息Code: ${res.data.message}`)
          }
        })
        .catch(function (err) {
          if (err) {
            console.log('error:' + err)
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/error.js